import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { combineLatest } from 'rxjs';
import { SubscriberInformationService } from './SubscriberInformationService';

@Injectable({
  providedIn: "root"
})
export class SubscriberInformationResolver implements Resolve<[models.SubscriberInformationVM]> {

  constructor(private http: HttpClient, private subscriberInformationService: SubscriberInformationService) {
    this.subscriberObservable = this.subscriberInformationService.getCurrentSubscriber()
      .toPromise().then((subscriber) => this.subscriber = subscriber)
      ;
  }

  public subscriber: models.SubscriberInformationVM;
  public subscriberObservable: Promise<models.SubscriberInformationVM>;

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return combineLatest(this.subscriberObservable);
  }
}
